import { reactive, ref, computed, onBeforeMount } from '@vue/composition-api'
import * as apiGuide from '@/api/guide'
import * as _ from 'lodash'

export const GuideList = (props, context) => {

  const store = context.root.$store
  const router = context.root.$router
  const { guide } = store.state

  onBeforeMount(() => {
    action.load()
  })

  const state = reactive({
    lists: computed(() => store.getters['guide/lists']),
    isSearch: computed(() => store.getters['guide/isSearch']),
    visibleMenu: false,
    visibleWindowDetail: false,
    visibleSearchDetail: false, // 詳細検索ウィンドウ表示フラグ
    isFocusInput: false
  })

  const action = {
    load: () => {
      store.dispatch('guide/search', true)
      const countParams = store.getters['guide/countRequest']
      apiGuide
        .count(countParams)
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            store.dispatch('guide/setCount', data.count)
          }
        })

      const params = store.getters['guide/searchRequest']
      apiGuide
        .list(params)
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            store.dispatch('guide/setLists', data.list)
          }
        })
        .finally(() => {
          store.dispatch('guide/search', false)
        })
    },
    pagenation: ({ currentPage, start }) => {
      store.dispatch('guide/search', true)
      store.dispatch('guide/setPageNation', { currentPage, start })

      const params = store.getters['guide/searchRequest']
      apiGuide
        .list(params)
        .then(res => {
          const { data } = res
          if (data.status === 0) {
            store.dispatch('guide/setLists', data.list)
          }
        })
        .finally(() => {
          store.dispatch('guide/search', false)
        })
    },
    searchReset: () => {
      store.dispatch('guide/setKeyword', '')
      store.dispatch('guide/pageReset')
      store.dispatch('guide/setCurrentId', null)

      action.load()
    }
  }

  return {
    state,
    guide,
    action
  }
}
